import { useCallback } from "react";

import {
  resetClaimDetails,
  resetClaimDocuments,
  resetClaimReporter,
  resetLossDetails,
  resetPolicyDetails,
} from "@redux/slices";
import { useAppDispatch } from "./useAppDispatch";

export function useResetState() {
  const dispatch = useAppDispatch();
  const resetState = useCallback(() => {
    dispatch(resetClaimDetails());
    dispatch(resetClaimDocuments());
    dispatch(resetClaimReporter());
    dispatch(resetLossDetails());
    dispatch(resetPolicyDetails());
  }, [dispatch]);

  return resetState;
}
